import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
} from '@angular/core';
import {
  AppState,
  FilterOption,
  FilterState,
  RoomCountFilterState,
  RoomCountOption,
  RoomCountRange,
} from '@immosky/types';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
  isRoomCountFilterActive,
  selectFilterState,
} from '@immosky/object-search-filter';

@Component({
  selector: 'lib-room-count-filter',
  templateUrl: './room-count-filter.component.html',
  styleUrls: ['./room-count-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomCountFilterComponent implements OnDestroy {
  private roomCountSubscription!: Subscription;

  options: RoomCountOption[] = [];
  currentFilter!: RoomCountRange;
  roomCountFilterState!: RoomCountFilterState;

  @Output()
  update = new EventEmitter<RoomCountRange>();

  get defaultMinOption() {
    return this.options[0];
  }

  get defaultMaxOption() {
    return this.options[this.options.length - 1];
  }

  get canReset(): boolean {
    return isRoomCountFilterActive(
      this.currentFilter,
      this.roomCountFilterState.default
    );
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.roomCountSubscription = this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.roomCountFilterState = filterState.roomCount;
        this.currentFilter = {
          ...this.roomCountFilterState.filter,
        };
        this.options = this.roomCountFilterState.options;
        this.cdRef.markForCheck();
      });
  }

  ngOnDestroy(): void {
    this.roomCountSubscription.unsubscribe();
  }

  onMinChange(option: FilterOption) {
    const newMinOption = option as RoomCountOption;

    if (newMinOption.value > this.currentFilter.max.value) {
      this.currentFilter.min = newMinOption;
      this.currentFilter.max = newMinOption;
    } else {
      this.currentFilter.min = newMinOption;
    }

    this.emitChange();
  }

  onMaxChange(option: FilterOption) {
    const newMaxOption = option as RoomCountOption;

    if (newMaxOption.value < this.currentFilter.min.value) {
      this.currentFilter.min = newMaxOption;
      this.currentFilter.max = newMaxOption;
    } else {
      this.currentFilter.max = newMaxOption;
    }

    this.emitChange();
  }

  reset() {
    this.currentFilter.min = this.options[0];
    this.currentFilter.max = this.options[this.options.length - 1];
    this.emitChange();
  }

  emitChange() {
    this.update.emit(this.currentFilter);
  }
}
